import React, { Component } from "react";
import { Link } from "react-router-dom";
import swal from "sweetalert";
export class Success extends Component {
  render() {
    return (
      <>
        <h3>Success</h3>
        {swal("Good job!", "Your profile is built!", "success").then(() => {
          window.location.href = "/";
        })}
      </>
    );
  }
}

export default Success;
